import React from 'react';
import { Translate } from 'react-localize-redux';
import partnerCss from './style.css';
import SingularLogoIcon from '../resources/svg/singular_logo_blue_figma.svg';
import PartnerCheckIcon from '../resources/svg/partner_check_icon.svg';
import G2Logo from '../resources/svg/g2_logo.svg';
import G2Stars from '../resources/svg/g2_stars.svg';
import G2BestResults from '../resources/svg/g2_best_results.svg';
import G2BestRelationship from '../resources/svg/g2_best_relationship.svg';

const TRANSLATE_PREFIX = 'STATIC.PAGES.PARTNER_SIGNUP';

const SIDEBAR_BENEFITS = [
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_1`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_2`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_3`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_4`,
];

export default function PartnerSidebar() {
    return (
        <div className={partnerCss.partnerSidebar}>
            <div className={partnerCss.sidebarContent}>
                <div className={partnerCss.sidebarHeader}>
                    <SingularLogoIcon className={partnerCss.sidebarLogo} />
                    <div className={partnerCss.sidebarTitle}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_TITLE`} />
                    </div>
                    <div className={partnerCss.sidebarDescription}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_DESCRIPTION`} />
                    </div>
                </div>
                <div className={partnerCss.sidebarBenefitsSection}>
                    <div className={partnerCss.sidebarSectionTitle}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_WHY_TITLE`} />
                    </div>
                    <div className={partnerCss.sidebarBenefitsList}>
                        {SIDEBAR_BENEFITS.map(benefitKey => (
                            <div key={benefitKey} className={partnerCss.sidebarBenefitItem}>
                                <PartnerCheckIcon className={partnerCss.sidebarBenefitIcon} />
                                <div className={partnerCss.sidebarBenefitText}>
                                    <Translate id={benefitKey} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={partnerCss.sidebarFooter}>
                <div className={partnerCss.sidebarFooterSeparator} />
                <div className={partnerCss.sidebarFooterTitle}>
                    <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_FOOTER`} />
                </div>
                <div className={partnerCss.sidebarBadges}>
                    <div>
                        <G2Logo className={partnerCss.sidebarG2Logo} />
                        <G2Stars className={partnerCss.sidebarG2Stars} />
                    </div>
                    <G2BestResults className={partnerCss.sidebarBadge} />
                    <G2BestRelationship className={partnerCss.sidebarBadge} />
                </div>
            </div>
        </div>
    );
}